import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  accounts: [],
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  }
};

// getters
export const getters = {
  accounts: state => state.accounts,
  pagination: state => state.pagination
};

// mutations
export const mutations = {
  [types.ACCOUNT.FETCH_ACCOUNT](state, accounts) {
    state.accounts = accounts;
    state.pagination.from = accounts.from;
    state.pagination.to = accounts.to;
    state.pagination.totalPage = accounts.last_page;
    state.pagination.path = accounts.path;
    state.pagination.currentPage = accounts.current_page;
    state.pagination.totalRecord = accounts.total;
    state.pagination.perPage = accounts.per_page;
  }
};

// actions
export const actions = {
  async fetchAccount({ commit }, payload) {
    const response = await axios.get(api.LIST_ACCOUNT, {
      params: {
        per_page: payload.optionPage,
        page: payload.currentPage,
        sort_column: payload.columnSort,
        sort_by: payload.sortBy,
        name: payload.name,
        company_code: payload.company_code,
        foot_code: payload.footCode,
        division_code: payload.divisionCode,
        position_id: payload.positionId
      }
    });
    commit(types.ACCOUNT.FETCH_ACCOUNT, response.data);
  },
  // eslint-disable-next-line
  async resetPassword({ commit }, accountId) {
    await axios.post(api.RESET_PASSWORD + "/" + accountId);
  }
};
